import { render, staticRenderFns } from "./TotalMix.vue?vue&type=template&id=68a7e7f4&scoped=true&"
import script from "./TotalMix.vue?vue&type=script&lang=js&"
export * from "./TotalMix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a7e7f4",
  null
  
)

export default component.exports